import { Platform } from 'react-native'
import type { Theme } from '../../theme/getTheme'

export const getChallengesMenuStyleSheet = (_theme: Theme) => ({
  menuOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    justifyContent: 'flex-start' as const,
    alignItems: 'flex-end' as const,
    paddingTop: Platform.OS === 'web' ? 60 : 50,
    paddingRight: 20,
    ...(Platform.OS === 'web' && {
      position: 'fixed' as never,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
    }),
  },
  menuContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    minWidth: 200,
    maxWidth: 250,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 8,
    overflow: 'hidden' as const,
    zIndex: Platform.OS === 'web' ? 10000 : 1001,
    marginTop: 0,
    marginRight: 0,
  },
  menuHeader: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    backgroundColor: '#F8FAFC',
  },
  menuTitle: {
    fontSize: 16,
    fontWeight: '700' as const,
    color: '#1A202C',
    letterSpacing: 0.5,
  },
  menuUserInfo: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
    backgroundColor: '#EDF2F7',
  },
  menuUserName: {
    fontSize: 15,
    fontWeight: '600' as const,
    color: '#2D3748',
  },
  menuItem: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  menuItemCancel: {
    borderBottomWidth: 0,
    justifyContent: 'center' as const,
    backgroundColor: '#F8FAFC',
  },
  menuItemIcon: {
    fontSize: 18,
    marginRight: 12,
  },
  menuItemText: {
    fontSize: 15,
    fontWeight: '600' as const,
    color: '#1A202C',
  },
  menuItemTextCancel: {
    fontSize: 15,
    fontWeight: '600' as const,
    color: '#718096',
    textAlign: 'center' as const,
  },
  menuSection: {
    paddingVertical: 14,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#E2E8F0',
  },
  menuSectionTitle: {
    fontSize: 11,
    fontWeight: '700' as const,
    color: '#718096',
    textTransform: 'uppercase' as const,
    letterSpacing: 1,
    marginBottom: 10,
  },
  themeSwitcher: {
    flexDirection: 'row' as const,
    gap: 8,
  },
  themeOption: {
    flex: 1,
    paddingVertical: 10,
    paddingHorizontal: 8,
    borderRadius: 8,
    backgroundColor: '#2D3748',
    borderWidth: 1,
    borderColor: '#4A5568',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
  },
  themeOptionActive: {
    backgroundColor: '#9F7AEA',
    borderColor: '#9F7AEA',
  },
  themeOptionText: {
    fontSize: 12,
    fontWeight: '600' as const,
    color: '#FFFFFF',
  },
  themeOptionTextActive: {
    color: '#FFFFFF',
    fontWeight: '700' as const,
  },
})
